
export class Value {
    timestamp: number;
    value: number;
}

export class Measurement {
    id: string;
    name: string;
    unit: string;
    value: number;
}

